import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {AuthService, StorageService} from '@cosbeni/auth';
import * as wjcCore from '@mescius/wijmo';
import {LoadUserAction} from '../ngrx/actions/user.action';
import {Capability, canWith, CAPS} from '../services/roles';

/**
 * 買取屋 (kaitoriya) 業務のコンテナ (枠のみ)。kobeac-container と同じシェル構造で
 * サイドナビだけ買取屋用に差し替える。中身の画面は準備中プレースホルダ。
 */
@Component({
    standalone: false,
    selector: 'app-kaitoriya-container',
    templateUrl: './kaitoriya-container.component.html',
})
export class KaitoriyaContainerComponent {
    user: any;
    readonly CAPS = CAPS;
    private database: string;

    constructor(private store: Store<any>, private auth: AuthService, private storage: StorageService) {
        this.store.dispatch(new LoadUserAction());
        this.store.select<any>('activePromotionFeature').subscribe((feature: any) => {
            if (wjcCore.isObject(feature.user) && feature.user.loaded) {
                this.user = feature.user.user;
            }
        });
        this.database = this.storage.get('database');
    }

    logout(): void {
        this.auth.logout().subscribe(() => {
        });
        this.storage.remove(this.database + '_url');
    }

    can(capability: Capability | Capability[]): boolean {
        return canWith(wjcCore.isObject(this.user) ? this.user.roles : null, capability);
    }
}
